import { render } from "./tables.vue?vue&type=template&id=1c2cb8ac&ts=true"
import script from "./tables.vue?vue&type=script&lang=ts"
export * from "./tables.vue?vue&type=script&lang=ts"

import "./tables.vue?vue&type=style&index=0&id=1c2cb8ac&lang=css"

import exportComponent from "/var/www/prod/LVCManagerWebsitePerso/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__